import { type Application } from '~/utils'

import { HeaderContent } from './components/HeaderContent'
import { Logo } from './components/Logo'
import { NavigationContent } from './components/NavigationContent'
import { rootPath } from './routes/paths'
import { Root } from './routes/Root'

export const application: Application = {
  HeaderContent,
  id: 'analyzer',
  Logo,
  name: '9segs' as const,
  NavigationContent,
  Root,
  rootPath,
}
